module.exports = __webpack_public_path__ + "media/request-quote-form-platform.0cfe1118.mp4";